<template>
  <carousel
    :per-page="1"
    :pagination-padding="4"
    :value="selectedPage"
    :pagination-enabled="true"
    pagination-active-color="#4c7499"
  >
    <slide
      v-for="(clientChunk, clientChunkIndex) in clientsChunked"
      :key="clientChunkIndex"
    >
      <div class="row">
        <div
          v-for="client in clientChunk"
          :key="client.Id"
          class="col-xs-6"
        >
          <featured-client :client="client" />
        </div>
      </div>
    </slide>
  </carousel>
</template>

<script>
import FeaturedClient from './FeaturedClient.vue'
import { Carousel, Slide } from '@Shared/components/VueCarousel'
import { chunk } from 'lodash'

export default {
  name: 'ClientCarousel',
  components: {
    Carousel,
    FeaturedClient,
    Slide
  },
  props: {
    clients: { type: Array, default: function () { return [] }, required: true }
  },
  data () {
    return {
      numClientsPerSlide: 2,
      selectedPage: 1
    }
  },
  computed: {
    clientsChunked () {
      return chunk(this.clients, this.numClientsPerSlide)
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// WebResources/vue/pictureday/home/index/components/ContentItems/GradClientCarousel.vue